<template>
    <el-dialog
        :class="['lnk-audit-trail',themeClass]"
        :close-on-click-modal="false"
        :visible.sync="isVisible"
        :title="$t('LnkAuditTrail.title')"
        append-to-body>
        <table-control
            :islocal="true"
            :tools-show="false"
            :pg-sizes="[10,20,50,100]"
            :row-height="36"
            pager-layout="sizes,prev,next,jumper,->,slot"
            :sort-all="false"
            :data="tableRows">
            <template slot="table" slot-scope="table">
                <el-table v-bind="table.props">
                    <el-table-column indexing width="55"/>
                    <el-table-column :label="$t('LnkAuditTrail.fieldAttr1')" prop="attr1" min-width="100" show-overflow-tooltip/>
                    <el-table-column :label="$t('LnkAuditTrail.fieldAttr2')"  prop="attr2" min-width="100" show-overflow-tooltip/>
                    <el-table-column :label="$t('LnkAuditTrail.fieldOperate')" prop="operate" min-width="60" lov="TRACK_TYPE"/>
                    <el-table-column :label="$t('LnkAuditTrail.fieldCreated')" prop="created" min-width="140"
                                     lnktype="date" date-format="yyyy-MM-dd hh:mm:ss"/>
                    <el-table-column
                        v-for="(col,index) in tableFields"
                        :label="col.label"
                        :key="index">
                        <el-table-column :label="$t('LnkAuditTrail.fieldOldValue')" :prop="col.oldField" min-width="100" show-overflow-tooltip/>
                        <el-table-column :label="$t('LnkAuditTrail.fieldNewValue')" :prop="col.newField" min-width="100" show-overflow-tooltip/>
                    </el-table-column>
                </el-table>
            </template>
        </table-control>
        <span slot="footer">
            <el-button type="primary" @click="isVisible=false">{{$t('global.close')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import themeClass from '@mixins/theme-class';
import tableControl from '../lnk-table-datapanel';
export default {
    name: 'lnk-audit-trail',
    mixins: [themeClass],
    components: {tableControl},
    watch: {
        isVisible: {
            immediate: true,
            handler: function (val) {
                if(val){
                    this.appendToBody();
                }else {
                    this.removeFromBody();
                }
            }
        }
    },
    data(){
        return {
            /* 是否展示 */
            isVisible: true,
            /* 展示列 */
            tableFields: [],
            /* 展示数据 */
            tableRows: []
        };
    },
    methods: {
        appendToBody(){
            try {
                document.body.appendChild(this.$el);
            }catch (e) {}
        },
        removeFromBody(){
            try {
                document.body.removeChild(this.$el);
            }catch (e) {}
        }
    },
    beforeDestroy(){
        this.removeFromBody();
    }
};
</script>

<style scoped lang="scss">
    /deep/.lnk-audit-trail{
        .el-dialog{
            position: absolute;
            margin: 0!important;
            left: calc(50% - 400px);
            top:calc(50% - 282px);
            width: 800px;
            max-height: initial!important;
            max-width: initial!important;
            .el-dialog__body{
                max-height: initial!important;
            }
            .table-panel.lnk-table-datapanel .rows.in-duty{
                margin-top: 0!important;
            }
            .table-panel.lnk-table-datapanel .rows .el-table .el-table-header-row {
                .is-leaf .cell:hover{
                    background: #F5F6FA;
                }
                th .cell{
                    text-align: center;
                }
                th.is-leaf .cell{
                    text-align: left;
                }

            }
            .lnk-pagination-v{
                border: 0!important;
                height: 28px!important;
                padding: 0!important;
                margin-top:8px;

                .el-pagination{
                    padding: 0!important;
                    .el-pagination__sizes{
                        margin: 0 0 0 -5px;
                    }
                    .el-pagination__jump{
                        margin-left: 6px;
                    }
                    .el-select .el-input{
                        width: 80px;
                    }
                    .btn-prev{
                        margin-right: 4px;
                        padding-right: 6px;
                    }
                    .btn-next{
                        padding-left: 6px;
                    }
                    button{
                        min-width: 28px;
                    }
                }
            }
        }
    }
</style>
